export default function darkModeToggle() {
    return {
        theme: localStorage.getItem("theme") || (matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"),

        init() {
            this.applyTheme();
            matchMedia("(prefers-color-scheme: dark)").addEventListener("change", e => {
                if (!localStorage.getItem("theme")) this.theme = e.matches ? "dark" : "light", this.applyTheme();
            });
        },

        toggleTheme() {
            localStorage.setItem("theme", this.theme = this.theme === "dark" ? "light" : "dark");
            this.applyTheme();
        },

        applyTheme() {
            document.documentElement.setAttribute("data-theme", this.theme);
        }
    };
}